module.exports = __webpack_public_path__ + "img/1593210061.3bc4f783.jpg";